var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search-Item",
    transform: "translate(-1828 -360)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7409",
    "data-name": "Rectangle 7409",
    width: 41,
    height: 36,
    rx: 3,
    transform: "translate(1828 360)",
    fill: "#2468ff",
    opacity: 0.072
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M9387.979,14257.08l-3.8-3.8a6.9,6.9,0,1,1,1.1-1.1l3.8,3.8a.775.775,0,0,1,.226.551.761.761,0,0,1-.226.552.784.784,0,0,1-.551.229A.776.776,0,0,1,9387.979,14257.08Zm-13.422-9.192a5.332,5.332,0,1,0,5.331-5.328A5.335,5.335,0,0,0,9374.558,14247.888Z",
    transform: "translate(-7533 -13870.996)",
    fill: "#2179fe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchItem);
export default __webpack_public_path__ + "static/media/SearchItem.727865ed.svg";
export { ForwardRef as ReactComponent };